export const styles = theme => ({
    container: {
        flexGrow: 1,
        display: "block",
        marginBottom: 100,
    },    
    title: {
        "& h3": {
            margin: "1.5rem 0",
        },
        "& h4": {
            margin: "1rem 0"
        },
        margin: "2rem 0",
        "& h5": {
            margin: "0.7rem 0"
        },
        "& h6": {
            margin: "0.7rem 0"
        },
    },
    link: {
        color: '#000099'
    }
});
